(function () {
  "use strict";
  var root = document.querySelector("[data-fsgf]");
  if (!root) return;
  var $ = function (id) { return document.getElementById("fsgf-" + id); };
  // Flying Solo "Will it fit?" guide: each bag drawn to scale from its
  // product photos, with the shopper's things packed inside.
  // Sizes in cm, as seen in the drawing: w across, h up, d into the page.
  // Tully sizes inside are Flying Solo's own; the rest are the outside size
  // less walls and padding.
  var BAGS = [
    { id: "killswitch", name: "Killswitch Pack V2", family: "Killswitch Pack V2", shape: "belt", vol: null, volText: "Slim",
      out: { w: 22, h: 15, d: 0.5 }, spaces: [{ name: "Pouch", w: 21, h: 14, d: 2 }],
      info: "Sits flat on your belt, under your jacket. Best for slim things up to about 2 cm thick." },
    { id: "octane", name: "Octane Leg Bag", family: "Octane Leg Bag (X-Pac Version)", shape: "leg", vol: null, volText: "Expands",
      out: { w: 18, h: 23, d: 9 }, spaces: [{ name: "Main compartment", w: 17, h: 22, d: 8 }],
      info: "The compartment is 5 cm deep and expands to 9 cm, nearly doubling the room. Phones go in the dedicated waterproof pocket." },
    { id: "ashx", name: "Ashvault X 15L", family: "Ashvault X Backpack 15L", shape: "pack", vol: 15,
      out: { w: 28, h: 40, d: 15 }, spaces: [{ name: "Main compartment", w: 26, h: 37, d: 12, fromBack: true, taper: 15.1 }, { name: "Laptop sleeve", w: 22, h: 31, d: 2.5, laptop: 13 }],
      info: "The padded sleeve holds a back protector, hydration pack or 13\" laptop (15\" MacBook Air) alongside everything else." },
    { id: "ashg", name: "Ashvault G 22L", family: "Ashvault G Backpack 22L", shape: "pack", vol: 22,
      out: { w: 30, h: 46, d: 15 }, spaces: [{ name: "Main compartment", w: 28, h: 43, d: 12, fromBack: true, taper: 15.1 }, { name: "Laptop sleeve", w: 25.5, h: 36, d: 2.5, laptop: 16 }],
      info: "The padded sleeve holds a back protector, hydration pack or 16\" laptop alongside everything else." },
    { id: "tully-s", name: "Tully Small 7L", family: "Tully Waterproof Tailbags", size: "Small 7L", shape: "tail", vol: 7,
      out: { w: 27, h: 15, d: 22.5 }, spaces: [{ name: "Main compartment", w: 26, h: 10, d: 21 }, { name: "Top pocket", w: 24, h: 3.5, d: 19 }],
      info: "Tully bags are handmade, so allow ±1 cm. Sizes are taken at the middle of the bag." },
    { id: "tully-m", name: "Tully Medium 15L", family: "Tully Waterproof Tailbags", size: "Medium 15L", shape: "tail", vol: 15,
      out: { w: 40, h: 16, d: 26 }, spaces: [{ name: "Main compartment", w: 38, h: 10, d: 23.5 }, { name: "Top pocket", w: 36, h: 4, d: 22 }],
      info: "Tully bags are handmade, so allow ±1 cm. Sizes are taken at the middle of the bag." },
    { id: "tully-l", name: "Tully Large 22L", family: "Tully Waterproof Tailbags", size: "Large 22L", shape: "tail", vol: 22,
      out: { w: 47, h: 25, d: 33 }, spaces: [{ name: "Main compartment", w: 42, h: 20, d: 30 }, { name: "Top pocket", w: 42, h: 7, d: 28 }],
      info: "Tully bags are handmade, so allow ±1 cm. Sizes are taken at the middle of the bag." },
    { id: "roxby", name: "Roxby Duffel 60L", family: "Roxby Adventure Duffel", shape: "duffel", vol: 60,
      out: { w: 60, h: 46, d: 31.5 }, spaces: [{ name: "Main compartment", w: 58, h: 42, d: 30 }],
      info: "Roll top, so it shrinks down to the load. Fully waterproof, with webbing for RokStraps, Andy Strapz and Naz Bags." }
  ];
  var PRESETS = [
    { id: "phone", name: "Large phone", d: [16.3, 7.8, 0.9], kind: "phone" },
    { id: "wallet", name: "Wallet", d: [11, 9, 2], kind: "box" },
    { id: "sunnies", name: "Sunnies case", d: [16, 6.5, 5], kind: "round" },
    { id: "ipad", name: "11\" iPad", d: [24.8, 17.9, 0.6], kind: "tablet" },
    { id: "lap13", name: "13\" laptop", d: [30.4, 21.5, 1.6], laptop: 13, kind: "laptop" },
    { id: "lap16", name: "16\" laptop", d: [35.6, 24.8, 1.8], laptop: 16, kind: "laptop" },
    { id: "bottle", name: "1L water bottle", d: [27, 9, 9], kind: "bottle" },
    { id: "disc", name: "Disc lock", d: [11, 8, 4], kind: "box" },
    { id: "rain", name: "Packed rain jacket", d: [25, 20, 9], kind: "soft" },
    { id: "camera", name: "Camera + lens", d: [13, 10, 9], kind: "box" },
    { id: "cover", name: "Packed bike cover", d: [30, 20, 12], kind: "soft" },
    { id: "sleeping", name: "Sleeping bag", d: [40, 22, 22], kind: "soft" },
    { id: "helmet", name: "Full-face helmet", d: [34, 27, 27], kind: "helmet" }
  ];
  // The bag comes from the link on its product page (?bag=ashx).
  var want = new URLSearchParams(location.search).get("bag");
  var S = { bag: BAGS.some(function (b) { return b.id === want; }) ? want : "tully-m", units: "cm", picked: ["lap13", "bottle"], custom: [] };
  var LINKS = {};
  try { LINKS = JSON.parse(root.querySelector("[data-fsgf-links]").textContent); } catch (e) {}
  var esc = function (s) { return String(s).replace(/[&<>"]/g, function (c) { return { "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;" }[c]; }); };
  function len(cm) { var v = S.units === "in" ? cm / 2.54 : cm; return String(Math.round(v * 10) / 10); }
  function u() { return S.units === "in" ? "\"" : " cm"; }
  function trio(a, b, c) { return len(a) + " × " + len(b) + " × " + len(c) + u(); }
  function bagById(id) { return BAGS.filter(function (b) { return b.id === id; })[0]; }
  function items() { return PRESETS.filter(function (p) { return S.picked.indexOf(p.id) > -1; }).concat(S.custom); }
  var PERM = [[0, 1, 2], [0, 2, 1], [1, 0, 2], [1, 2, 0], [2, 0, 1], [2, 1, 0]];

  // An item laid flat in a space: the way round that fits its floor with
  // the least height, or null if its footprint doesn't fit at all.
  function flat(it, sp) {
    if (sp.laptop) {
      // The sleeve stands upright and takes one flat thing.
      if (it.laptop) return it.laptop <= sp.laptop ? { w: it.d[1], h: it.d[0], d: it.d[2], slack: sp.laptop - it.laptop + 1 } : null;
      var s = it.d.slice().sort(function (a, b) { return b - a; });
      return s[2] <= sp.d && s[1] <= sp.w && s[0] <= sp.h ? { w: s[1], h: s[0], d: s[2], slack: Math.min(sp.w - s[1], sp.h - s[0]) } : null;
    }
    var all = flatAll(it, sp);
    return all.length ? all[0] : null;
  }
  // Every way round that fits, lowest first.
  function flatAll(it, sp) {
    if (sp.laptop) { var one = flat(it, sp); return one ? [one] : []; }
    var out = [];
    PERM.forEach(function (o) {
      var w = it.d[o[0]], h = it.d[o[1]], d = it.d[o[2]];
      if (w <= sp.w && d <= sp.d && h <= sp.h) out.push({ w: w, h: h, d: d, slack: Math.min(sp.w - w, sp.d - d) });
    });
    return out.sort(function (a, b) { return a.h - b.h || a.w - b.w; });
  }
  // The closest it comes, for the reason it won't go in.
  function nearest(it, sp) {
    var best = null;
    PERM.forEach(function (o) {
      var w = it.d[o[0]], h = it.d[o[1]], d = it.d[o[2]];
      var over = Math.max(0, w - sp.w) + Math.max(0, h - sp.h) + Math.max(0, d - sp.d);
      if (!best || over < best.over) best = { w: w, h: h, d: d, over: over };
    });
    return best;
  }
  // Packs a space like a Jenga tower: the biggest things go in first and
  // everything sits as low and as far forward as it can, filling the gaps
  // beside and above what's already in. Each spot tried is a corner of
  // something already packed.
  function overlap(a, b) {
    return a.x < b.x + b.w - 0.01 && b.x < a.x + a.w - 0.01 && a.y < b.y + b.h - 0.01 && b.y < a.y + a.h - 0.01 && a.z < b.z + b.d - 0.01 && b.z < a.z + a.d - 0.01;
  }
  function tryPlace(st, it) {
    var opts = flatAll(it, st.sp);
    if (!opts.length) return null;
    if (st.sp.laptop) {
      if (st.boxes.length) return "full";
      var o = opts[0], bx = { x: (st.sp.w - o.w) / 2, y: 0, z: 0, w: o.w, h: o.h, d: o.d, it: it, o: o };
      st.boxes.push(bx); return bx;
    }
    var best = null;
    st.points.forEach(function (p) {
      opts.forEach(function (o) {
        var bx = { x: p.x, y: p.y, z: p.z, w: o.w, h: o.h, d: o.d };
        if (bx.x + bx.w > st.sp.w + 0.01 || bx.y + bx.h > st.sp.h + 0.01 || bx.z + bx.d > st.sp.d + 0.01) return;
        if (st.sp.taper && bx.z + bx.d > st.sp.d - tearOffset((bx.y + bx.h) / st.sp.h) * st.sp.taper + 0.01) return;
        // it has to rest on the floor or on something
        if (bx.y > 0.01 && !st.boxes.some(function (b) { return Math.abs(b.y + b.h - bx.y) < 0.02 && bx.x < b.x + b.w && b.x < bx.x + bx.w && bx.z < b.z + b.d && b.z < bx.z + bx.d; })) return;
        if (st.boxes.some(function (b) { return overlap(b, bx); })) return;
        var score = (bx.y + bx.h) * 1000 + bx.z * 10 + bx.x;
        if (!best || score < best.score) best = { bx: bx, o: o, score: score };
      });
    });
    if (!best) return "full";
    var b = best.bx; b.it = it; b.o = best.o;
    st.boxes.push(b);
    st.points = st.points.filter(function (p) { return !(p.x >= b.x && p.x < b.x + b.w && p.y >= b.y && p.y < b.y + b.h && p.z >= b.z && p.z < b.z + b.d); });
    st.points.push({ x: b.x + b.w, y: b.y, z: b.z }, { x: b.x, y: b.y + b.h, z: b.z }, { x: b.x, y: b.y, z: b.z + b.d });
    return b;
  }
  function judge(bag, list) {
    var stacks = bag.spaces.map(function (sp) { return { sp: sp, boxes: [], points: [{ x: 0, y: 0, z: 0 }] }; });
    // flat things go in the sleeve or top pocket first, keeping the main space free
    var order = stacks.slice(1).concat(stacks[0]);
    var rows = [], level = "ok";
    list.slice().sort(function (a, b) { return b.d[0] * b.d[1] * b.d[2] - a.d[0] * a.d[1] * a.d[2]; }).forEach(function (it) {
      var placed = null, footprintFits = false;
      for (var i = 0; i < order.length && !placed; i++) {
        var r = tryPlace(order[i], it);
        if (r) footprintFits = true;
        if (r && r !== "full") placed = { st: order[i], b: r };
      }
      if (placed) {
        var o = placed.b.o, sp = placed.st.sp;
        var tight = Math.min(sp.w - o.w, sp.d - o.d, sp.h - o.h) < 1.5;
        if (tight && level === "ok") level = "tight";
        rows.push({ it: it, ok: true, tight: tight, sp: sp, o: o });
      } else {
        level = "no";
        var sp0 = bag.spaces[0], n = nearest(it, sp0), why;
        if (footprintFits) why = "no room left once the rest is packed";
        else {
          var ax = [["long", n.w - sp0.w], ["tall", n.h - sp0.h], ["deep", n.d - sp0.d]].sort(function (a, b) { return b[1] - a[1]; })[0];
          why = "too " + ax[0] + " by " + len(ax[1]) + u();
        }
        rows.push({ it: it, ok: false, sp: sp0, o: n, why: why });
      }
    });
    // keep the list in the order the shopper picked
    rows.sort(function (a, b) { return list.indexOf(a.it) - list.indexOf(b.it); });
    var main = stacks[0], room = main.sp.w * main.sp.h * main.sp.d;
    var share = main.boxes.reduce(function (t, b) { return t + b.w * b.h * b.d; }, 0) / room;
    if (level === "ok" && share > 0.7) level = "tight";
    return { level: level, rows: rows, share: share, stacks: stacks };
  }

  // ---------- bag drawings, traced from the product photos ----------
  // The outline of each bag from the front (or behind), at any size, so the
  // space inside can be drawn as the same shape, smaller.
  function shapePath(shape, x, oy, W, H) {
    var y = oy - H;
    if (shape === "pack") {
      // Ashvault from behind: even width, softly rounded top
      var r = Math.min(W * 0.3, H * 0.25), c = Math.min(8, W * 0.15);
      return "M" + x + "," + (y + r) + " Q" + x + "," + y + " " + (x + r) + "," + y + " L" + (x + W - r) + "," + y + " Q" + (x + W) + "," + y + " " + (x + W) + "," + (y + r) +
        " L" + (x + W) + "," + (oy - c) + " Q" + (x + W) + "," + oy + " " + (x + W - c) + "," + oy + " L" + (x + c) + "," + oy + " Q" + x + "," + oy + " " + x + "," + (oy - c) + "Z";
    }
    if (shape === "tail") {
      // Tully: straight upright walls, smooth rounded top, flat base
      var t = Math.min(H * 0.55, W * 0.18);
      return "M" + x + "," + oy + " L" + x + "," + (y + t) + " Q" + x + "," + y + " " + (x + t * 1.4) + "," + y + " L" + (x + W - t * 1.4) + "," + y +
        " Q" + (x + W) + "," + y + " " + (x + W) + "," + (y + t) + " L" + (x + W) + "," + oy + "Z";
    }
    if (shape === "leg") {
      // Octane: a squared oval, rounded top and bottom alike
      return squircle(x, y, W, H, Math.min(W, H) * 0.42);
    }
    var k = shape === "duffel" ? Math.min(W, H) * 0.2 : Math.min(6, H * 0.3);
    return squircle(x, y, W, H, k);
  }
  function squircle(x, y, W, H, k) {
    var oy = y + H;
    return "M" + (x + k) + "," + y + " L" + (x + W - k) + "," + y + " C" + (x + W - k * 0.3) + "," + y + " " + (x + W) + "," + (y + k * 0.3) + " " + (x + W) + "," + (y + k) +
      " L" + (x + W) + "," + (oy - k) + " C" + (x + W) + "," + (oy - k * 0.3) + " " + (x + W - k * 0.3) + "," + oy + " " + (x + W - k) + "," + oy +
      " L" + (x + k) + "," + oy + " C" + (x + k * 0.3) + "," + oy + " " + x + "," + (oy - k * 0.3) + " " + x + "," + (oy - k) +
      " L" + x + "," + (y + k) + " C" + x + "," + (y + k * 0.3) + " " + (x + k * 0.3) + "," + y + " " + (x + k) + "," + y + "Z";
  }
  // From the side: the same shapes, except the Ashvault, which is a
  // teardrop - flat against your back, slim at the top, full at the bottom.
  // The front of the bag is on the left, the back (rider or seat) on the right.
  // The Ashvault's front curve as fractions of depth (across) and height (up).
  var TEAR = [[0, 0], [0, 0.6], [0.25, 0.92], [0.4, 1]];
  function tearOffset(t) {
    // how far the front has curved in at height t (0 = floor, 1 = top)
    var best = 0;
    for (var i = 0; i <= 60; i++) {
      var u = i / 60, a = 1 - u;
      var bx = 3 * a * a * u * TEAR[1][0] + 3 * a * u * u * TEAR[2][0] + u * u * u * TEAR[3][0];
      var by = 3 * a * a * u * TEAR[1][1] + 3 * a * u * u * TEAR[2][1] + u * u * u * TEAR[3][1];
      if (by <= t) best = bx;
    }
    return best;
  }
  function sidePath(shape, x, oy, D, H) {
    if (shape !== "pack") return shapePath(shape === "tail" ? "tail" : shape, x, oy, D, H);
    var y = oy - H, c = Math.min(6, D * 0.25);
    return "M" + (x + D) + "," + (y + c) + " L" + (x + D) + "," + (oy - c) + " Q" + (x + D) + "," + oy + " " + (x + D - c) + "," + oy +
      " L" + (x + c * 1.5) + "," + oy + " Q" + x + "," + oy + " " + x + "," + (oy - c * 2) +
      " C" + x + "," + (oy - H * TEAR[1][1]) + " " + (x + D * TEAR[2][0]) + "," + (oy - H * TEAR[2][1]) + " " + (x + D * TEAR[3][0]) + "," + y +
      " L" + (x + D - c) + "," + y + " Q" + (x + D) + "," + y + " " + (x + D) + "," + (y + c) + "Z";
  }
  function bagSvg(bag, sc, ox, oy) {
    var W = bag.out.w * sc, H = bag.out.h * sc, x = ox, y = oy - H, p = "", det = "";
    var ink = "#1d1d1f", hi = "#3a3a3d";
    p = shapePath(bag.shape, x, oy, W, H);
    if (bag.shape === "pack") {
      // Ashvault: tall, domed top, straight sides, haul loop, strap at the side
      var r = W * 0.42;
      det += '<path d="M' + (x + W / 2 - 9) + "," + (y + 1) + " q9,-14 18,0" + '" fill="none" stroke="' + ink + '" stroke-width="3"/>';
      det += '<path d="M' + (x + W + 1) + "," + (y + 12) + " C" + (x + W + 14) + "," + (y + H * 0.35) + " " + (x + W + 12) + "," + (y + H * 0.7) + " " + (x + W + 3) + "," + (oy - 6) + '" fill="none" stroke="' + ink + '" stroke-width="5" stroke-linecap="round"/>';
      det += swirl(x + W / 2, y + H * 0.56, W * 0.3);
    } else if (bag.shape === "tail") {
      // Tully: low dome, wider at the base, sitting on a seat
      det += '<path d="M' + (x - 30) + "," + (oy + 3) + " L" + (x + W + 30) + "," + (oy + 3) + '" stroke="#b9bec6" stroke-width="5" stroke-linecap="round"/>';
      det += swirl(x + W / 2, y + H * 0.72, Math.min(W, H) * 0.22);
    } else if (bag.shape === "duffel") {
      // Roxby: barrel duffel, handles on top, webbing straps round it
      [0.3, 0.7].forEach(function (f) { det += '<path d="M' + (x + W * f - 14) + "," + (y + 1) + " q14,-22 28,0" + '" fill="none" stroke="' + ink + '" stroke-width="3.5"/>'; });
      [0.18, 0.82].forEach(function (f) { det += '<rect x="' + (x + W * f - 3) + '" y="' + y + '" width="6" height="' + H + '" fill="' + hi + '"/>'; });
      det += '<rect x="' + x + '" y="' + (oy - H * 0.16) + '" width="' + W + '" height="3" fill="#cfd3d9" opacity=".6"/>';
      det += swirl(x + W / 2, y + H * 0.55, H * 0.24);
    } else if (bag.shape === "leg") {
      // Octane: rounded body tapering at the base, hip belt and leg strap
      det += '<path d="M' + (x - 40) + "," + (y - 2) + " Q" + (x + W / 2) + "," + (y - 22) + " " + (x + W + 40) + "," + (y - 2) + '" fill="none" stroke="' + ink + '" stroke-width="7" stroke-linecap="round"/>';
      det += '<rect x="' + (x + W / 2 - 9) + '" y="' + (y - 18) + '" width="18" height="10" rx="2" fill="' + hi + '"/>';
      det += '<path d="M' + (x - 26) + "," + (oy - H * 0.3) + " L" + (x + W + 26) + "," + (oy - H * 0.3) + '" stroke="' + ink + '" stroke-width="4" stroke-linecap="round" opacity=".55"/>';
      det += swirl(x + W / 2, y + H * 0.55, W * 0.32);
    } else {
      // Killswitch: slim pouch on a long belt with a side-release buckle
      det += '<path d="M' + (x - 70) + "," + (y + H * 0.3) + " L" + x + "," + (y + H * 0.22) + " M" + (x + W) + "," + (y + H * 0.22) + " L" + (x + W + 70) + "," + (y + H * 0.05) + '" stroke="' + ink + '" stroke-width="7" stroke-linecap="round"/>';
      det += '<rect x="' + (x - 52) + '" y="' + (y + H * 0.2) + '" width="16" height="12" rx="2" fill="' + hi + '" transform="rotate(-6 ' + (x - 44) + " " + (y + H * 0.26) + ')"/>';
      det += swirl(x + W * 0.55, y + H * 0.55, H * 0.32);
    }
    return { outline: '<path d="' + p + '" fill="' + ink + '"/>', details: det };
  }
  // The Flying Solo swirl, simplified: a faint ring with a hooked tail.
  function swirl(cx, cy, r) {
    return '<g opacity=".28" fill="none" stroke="#8d9197" stroke-width="' + Math.max(1.5, r * 0.16) + '" stroke-linecap="round">' +
      '<path d="M' + (cx - r) + "," + cy + " A" + r + "," + r + " 0 1 1 " + (cx + r * 0.5) + "," + (cy + r * 0.87) + '"/>' +
      '<path d="M' + (cx - r * 0.45) + "," + cy + " A" + (r * 0.45) + "," + (r * 0.45) + " 0 1 1 " + (cx + r * 0.2) + "," + (cy + r * 0.4) + '"/></g>';
  }
  // Items, drawn as the things they are.
  function itemSvg(it, x, y, w, h, bad, side, look) {
    var f = bad ? "#c4483b" : "#d2815f", s = bad ? "#8f2d23" : "#a95b3c", g = "";
    var k = it.kind || "box";
    if (k === "laptop") {
      g += '<rect x="' + x + '" y="' + y + '" width="' + w + '" height="' + h + '" rx="2" fill="' + f + '" stroke="' + s + '"/>';
      if (!side) g += '<rect x="' + (x + w * 0.06) + '" y="' + (y + h * 0.08) + '" width="' + (w * 0.88) + '" height="' + (h * 0.8) + '" fill="#fff" opacity=".28"/>';
    } else if (k === "bottle" && look === "end") {
      var rr = Math.min(w, h) / 2;
      g += '<circle cx="' + (x + w / 2) + '" cy="' + (y + h / 2) + '" r="' + rr + '" fill="' + f + '" stroke="' + s + '"/><circle cx="' + (x + w / 2) + '" cy="' + (y + h / 2) + '" r="' + (rr * 0.4) + '" fill="' + s + '"/>';
    } else if (k === "bottle") {
      var vertical = look ? look === "up" : h >= w, a = vertical ? w : h;
      if (vertical) g += '<rect x="' + (x + a * 0.3) + '" y="' + y + '" width="' + (a * 0.4) + '" height="' + (a * 0.35) + '" rx="1.5" fill="' + s + '"/><rect x="' + x + '" y="' + (y + a * 0.3) + '" width="' + w + '" height="' + (h - a * 0.3) + '" rx="' + (a * 0.35) + '" fill="' + f + '" stroke="' + s + '"/>';
      else g += '<rect x="' + (x + w - a * 0.35) + '" y="' + (y + a * 0.3) + '" width="' + (a * 0.35) + '" height="' + (a * 0.4) + '" rx="1.5" fill="' + s + '"/><rect x="' + x + '" y="' + y + '" width="' + (w - a * 0.3) + '" height="' + h + '" rx="' + (a * 0.35) + '" fill="' + f + '" stroke="' + s + '"/>';
    } else if (k === "helmet") {
      g += '<path d="M' + x + "," + (y + h) + " L" + x + "," + (y + h * 0.5) + " A" + (w / 2) + "," + (h / 2) + " 0 0 1 " + (x + w) + "," + (y + h * 0.5) + " L" + (x + w) + "," + (y + h) + 'Z" fill="' + f + '" stroke="' + s + '"/>';
      g += '<rect x="' + (x + w * 0.18) + '" y="' + (y + h * 0.42) + '" width="' + (w * 0.64) + '" height="' + (h * 0.22) + '" rx="' + (h * 0.08) + '" fill="#fff" opacity=".35"/>';
    } else if (k === "soft" || k === "round") {
      g += '<rect x="' + x + '" y="' + y + '" width="' + w + '" height="' + h + '" rx="' + Math.min(w, h) * 0.3 + '" fill="' + f + '" stroke="' + s + '"/>';
    } else {
      g += '<rect x="' + x + '" y="' + y + '" width="' + w + '" height="' + h + '" rx="2" fill="' + f + '" stroke="' + s + '"/>';
    }
    if (w > 46 && h > 14 && look !== "end") g += '<text x="' + (x + w / 2) + '" y="' + (y + h / 2 + 4) + '" text-anchor="middle" font-family="Outfit,sans-serif" font-size="11" fill="#fff">' + esc(it.name.length > 14 ? it.name.slice(0, 13) + "…" : it.name) + "</text>";
    return g;
  }

  // Which way an item's long side runs, as seen in a view.
  function lookOf(bx, view) {
    var m = Math.max(bx.w, bx.h, bx.d);
    if (bx.h === m) return "up";
    if (view === "front") return bx.w === m ? "across" : "end";
    return bx.d === m ? "across" : "end";
  }
  function renderDiagram(bag, v) {
    var sp = bag.spaces[0], sleeve = bag.spaces[1] && bag.spaces[1].laptop ? bag.spaces[1] : null, top = bag.shape === "tail" ? bag.spaces[1] : null;
    // room either side of the front view for belts and straps
    var padL = bag.shape === "belt" ? 75 : bag.shape === "leg" ? 45 : bag.shape === "tail" ? 22 : 8;
    var padR = bag.shape === "belt" ? 75 : bag.shape === "leg" ? 45 : bag.shape === "pack" ? 18 : bag.shape === "tail" ? 22 : 8;
    var sideD = Math.max(bag.out.d, sp.d + (sleeve ? sleeve.d + 0.6 : 0) + 0.6);
    var sc = Math.min((440 - padL - padR - 40) / (bag.out.w + sideD), 215 / bag.out.h);
    var W = bag.out.w * sc, H = bag.out.h * sc, D = sideD * sc;
    var used = padL + W + padR + 40 + D, ox = (460 - used) / 2 + padL, oy = 255, sx = ox + W + padR + 40;
    var b = bagSvg(bag, sc, ox, oy);
    var svg = b.outline + b.details, defs = "";
    var txt = function (x, y, s) { return '<text x="' + x + '" y="' + y + '" text-anchor="middle" font-family="Outfit,sans-serif" font-size="11" fill="#3a506b">' + esc(s) + "</text>"; };
    var dash = ' fill="#2c2c2f" stroke="#e9edf2" stroke-width="1.2" stroke-dasharray="4 3"';
    var frames = [];
    // ----- front view -----
    var mw = sp.w * sc, mh = sp.h * sc, mx = ox + (W - mw) / 2;
    if (top) {
      var m = Math.max(3, (bag.out.w - sp.w) / 2 * sc), inner = shapePath("tail", ox + m, oy - m * 0.6, W - 2 * m, H - m * 1.4);
      var mBottom = oy - m * 0.6, divY = mBottom - mh;
      defs += '<clipPath id="cf-in"><path d="' + inner + '"/></clipPath><clipPath id="c-lo"><rect x="0" y="' + divY + '" width="460" height="300"/></clipPath><clipPath id="c-hi"><rect x="0" y="0" width="460" height="' + (divY - 2) + '"/></clipPath>';
      svg += '<path d="' + inner + '"' + dash + '/><g clip-path="url(#cf-in)"><path d="M0,' + (divY - 1) + ' H460" stroke="#e9edf2" stroke-width="1.2" stroke-dasharray="4 3"/></g>';
      frames.push({ sp: sp, view: "front", x: mx, y: divY, w: mw, h: mh, clip: ["cf-in", "c-lo"] });
      frames.push({ sp: top, view: "front", x: ox + (W - top.w * sc) / 2, y: divY - 2 - top.h * sc, w: top.w * sc, h: top.h * sc, clip: ["cf-in", "c-hi"] });
    } else {
      var gap = (bag.out.h - sp.h) / 2 * sc, mBot = oy - gap, fp = shapePath(bag.shape, mx, mBot, mw, mh);
      defs += '<clipPath id="cf-in"><path d="' + fp + '"/></clipPath>';
      svg += '<path d="' + fp + '"' + dash + "/>";
      frames.push({ sp: sp, view: "front", x: mx, y: mBot - mh, w: mw, h: mh, clip: ["cf-in"] });
    }
    // ----- side view -----
    var so = sidePath(bag.shape, sx, oy, D, H);
    svg += '<path d="' + so + '" fill="#1d1d1f"/>';
    if (bag.shape === "tail") svg += '<path d="M' + (sx - 14) + "," + (oy + 3) + " L" + (sx + D + 14) + "," + (oy + 3) + '" stroke="#b9bec6" stroke-width="5" stroke-linecap="round"/>';
    if (bag.shape === "pack") svg += '<path d="M' + (sx + D + 1) + "," + (oy - H + 10) + " C" + (sx + D + 16) + "," + (oy - H * 0.65) + " " + (sx + D + 14) + "," + (oy - H * 0.3) + " " + (sx + D + 2) + "," + (oy - 8) + '" fill="none" stroke="#1d1d1f" stroke-width="5" stroke-linecap="round"/>';
    if (bag.shape === "leg") svg += '<path d="M' + (sx + D) + "," + (oy - H) + " L" + (sx + D + 3) + "," + (oy - H - 10) + '" stroke="#1d1d1f" stroke-width="6" stroke-linecap="round"/>';
    if (bag.shape === "belt") svg += '<path d="M' + (sx + D + 1) + "," + (oy - H * 0.75) + " h18" + '" stroke="#1d1d1f" stroke-width="6" stroke-linecap="round"/>';
    if (bag.shape === "duffel") svg += '<path d="M' + (sx + D / 2 - 10) + "," + (oy - H + 1) + " q10,-18 20,0" + '" fill="none" stroke="#1d1d1f" stroke-width="3.5"/>';
    var mdd = sp.d * sc, sleeveD = sleeve ? sleeve.d * sc : 0;
    var innerD = mdd + (sleeve ? sleeveD + 0.6 * sc : 0), ix = sx + (D - innerD) / 2;
    if (top) {
      var m2 = Math.max(3, (sideD - sp.d) / 2 * sc), sin = shapePath("tail", sx + m2, oy - m * 0.6, D - 2 * m2, H - m * 1.4);
      defs += '<clipPath id="cs-in"><path d="' + sin + '"/></clipPath>';
      svg += '<path d="' + sin + '"' + dash + '/><g clip-path="url(#cs-in)"><path d="M0,' + (divY - 1) + ' H460" stroke="#e9edf2" stroke-width="1.2" stroke-dasharray="4 3"/></g>';
      frames.push({ sp: sp, view: "side", x: sx + (D - mdd) / 2, y: divY, w: mdd, h: mh, clip: ["cs-in", "c-lo"] });
      frames.push({ sp: top, view: "side", x: sx + (D - top.d * sc) / 2, y: divY - 2 - top.h * sc, w: top.d * sc, h: top.h * sc, clip: ["cs-in", "c-hi"] });
    } else {
      var sgap = (bag.out.h - sp.h) / 2 * sc, sBot = oy - sgap, sh = sp.h * sc;
      var sp2 = sidePath(bag.shape, ix, sBot, innerD, sh);
      defs += '<clipPath id="cs-in"><path d="' + sp2 + '"/></clipPath>';
      svg += '<path d="' + sp2 + '"' + dash + "/>";
      frames.push({ sp: sp, view: "side", x: ix, y: sBot - sh, w: mdd, h: sh, clip: ["cs-in"] });
      if (sleeve) {
        // the sleeve runs up the back, against your spine
        var slx = ix + innerD - sleeveD, slh = Math.min(sleeve.h * sc, sh);
        svg += '<g clip-path="url(#cs-in)"><path d="M' + (slx - 0.3 * sc) + "," + (sBot - sh) + " V" + sBot + '" stroke="#e9edf2" stroke-width="1.2" stroke-dasharray="4 3"/></g>';
        frames.push({ sp: sleeve, view: "side", x: slx, y: sBot - slh, w: sleeveD, h: slh, clip: ["cs-in"] });
      }
    }
    svg += txt(ox + W / 2, oy + 41, "Front") + txt(sx + D / 2, oy + 41, "Side");
    // ----- the towers, in both views -----
    if (v) v.stacks.forEach(function (st) {
      frames.filter(function (fr) { return fr.sp === st.sp; }).forEach(function (f) {
        var open = "", close = "";
        f.clip.forEach(function (c) { open += '<g clip-path="url(#' + c + ')">'; close += "</g>"; });
        svg += open;
        if (f.view === "front") {
          var k = Math.min(0.35 * sc, 10 / Math.max(1, st.sp.d) * 1.2);
          // distance from the front of the bag decides what sits behind
          var zf = function (bx) { return st.sp.fromBack ? st.sp.d - bx.z - bx.d : bx.z; };
          st.boxes.slice().sort(function (a, b) { return zf(b) - zf(a) || a.y - b.y || a.x - b.x; }).forEach(function (bx) {
            var z = zf(bx);
            var g = itemSvg(bx.it, f.x + bx.x * sc + z * k, f.y + f.h - (bx.y + bx.h) * sc - z * k, bx.w * sc, bx.h * sc, false, false, lookOf(bx, "front"));
            svg += z > 0.5 ? '<g opacity="' + Math.max(0.5, 1 - z / st.sp.d * 0.6).toFixed(2) + '">' + g + "</g>" : g;
          });
        } else {
          // from the side, depth runs across; things further along sit behind
          st.boxes.slice().sort(function (a, b) { return b.x - a.x || a.y - b.y; }).forEach(function (bx) {
            var zx = st.sp.fromBack ? f.x + f.w - (bx.z + bx.d) * sc : f.x + bx.z * sc;
            var g = itemSvg(bx.it, zx, f.y + f.h - (bx.y + bx.h) * sc, bx.d * sc, bx.h * sc, false, true, lookOf(bx, "side"));
            svg += bx.x > 0.5 ? '<g opacity="' + Math.max(0.55, 1 - bx.x / Math.max(1, st.sp.w) * 0.5).toFixed(2) + '">' + g + "</g>" : g;
          });
        }
        svg += close;
      });
    });
    // what won't go in waits on top of the bag, in red
    if (v) {
      var bad = v.rows.filter(function (r) { return !r.ok; }), y2 = oy - H - 8;
      bad.forEach(function (r) {
        var o = r.o.w >= r.o.h ? r.o : { w: r.o.h, h: r.o.w };
        var bw = Math.min(o.w * sc, W + padL), bh = Math.min(o.h * sc, 50);
        svg += itemSvg(r.it, Math.max(4, ox + (W - bw) / 2), y2 - bh, bw, bh, true);
        y2 -= bh + 3;
      });
    }
    var dimY = oy + 16;
    svg += '<path d="M' + ox + "," + (dimY - 6) + " v6 M" + ox + "," + (dimY - 3) + " H" + (ox + W) + " M" + (ox + W) + "," + (dimY - 6) + ' v6" stroke="#3a506b" fill="none"/>';
    svg += txt(ox + W / 2, dimY + 10, len(bag.out.w) + u()).replace('font-size="11"', 'font-size="12"');
    svg += '<path d="M' + sx + "," + (dimY - 6) + " v6 M" + sx + "," + (dimY - 3) + " H" + (sx + D) + " M" + (sx + D) + "," + (dimY - 6) + ' v6" stroke="#3a506b" fill="none"/>';
    svg += txt(sx + D / 2, dimY + 10, len(bag.out.d) + u()).replace('font-size="11"', 'font-size="12"');
    var lx = Math.max(10, ox - padL - 4);
    svg += '<text x="' + lx + '" y="' + (oy - H / 2) + '" text-anchor="middle" font-family="Outfit,sans-serif" font-size="12" fill="#3a506b" transform="rotate(-90 ' + lx + " " + (oy - H / 2) + ')">' + len(bag.out.h) + u() + "</text>";
    $("svg").innerHTML = "<defs>" + defs + "</defs>" + svg;
  }

  // One line per item, like Peak Promise's Locations rows.
  function renderScales(v) {
    if (!v) { $("scales").innerHTML = ""; return; }
    $("scales").innerHTML = '<div class="itemlist">' + v.rows.map(function (r) {
      var lvl = !r.ok ? "no" : r.tight ? "tight" : "ok";
      var where = r.ok ? r.sp.name + (r.tight ? ", snug" : "") : r.why;
      return '<div class="irow"><span class="dot ' + lvl + '"></span><span class="pn">' + esc(r.it.name) + '</span><span class="iw ' + lvl + '">' + esc(where.charAt(0).toUpperCase() + where.slice(1)) + "</span></div>";
    }).join("") + "</div>";
  }

  function render() {
    var bag = bagById(S.bag), list = items();
    var v = list.length ? judge(bag, list) : null;
    // switcher
    $("switcher").innerHTML = '<span class="lab">Bag:</span>' + BAGS.map(function (b) {
      return '<button type="button" class="chip" data-bag="' + b.id + '" aria-pressed="' + (b.id === S.bag) + '">' + esc(b.name) + "</button>";
    }).join("");
    $("d-sub").textContent = bag.family + (bag.size ? " · " + bag.size : "");
    var link = LINKS[bag.id];
    $("shop").hidden = !link;
    if (link) { $("shop").href = link; $("shop").textContent = "Shop the " + bag.name; }
    $("cap-line").textContent = (bag.vol ? bag.vol + "L · " : "") + trio(bag.out.w, bag.out.h, bag.out.d) + " outside";
    root.querySelectorAll(".units button").forEach(function (b) { b.setAttribute("aria-pressed", String(b.getAttribute("data-u") === S.units)); });
    root.querySelectorAll("#fsgf-custom input[type=number]").forEach(function (i) { i.placeholder = S.units; });
    // items
    $("presets").innerHTML = PRESETS.map(function (p) {
      return '<button type="button" class="item" data-item="' + p.id + '" aria-pressed="' + (S.picked.indexOf(p.id) > -1) + '">' + esc(p.name) + "</button>";
    }).join("") + S.custom.map(function (c, i) {
      return '<button type="button" class="item" data-custom="' + i + '" aria-pressed="true" title="Remove ' + esc(c.name) + '">' + esc(c.name) + " ✕</button>";
    }).join("");
    // verdict, in the size guide's "Your size" spot
    var others = BAGS.filter(function (b) { return b.id !== bag.id; }).map(function (b) { return { b: b, v: list.length ? judge(b, list) : null }; });
    var LABEL = { ok: "It fits", tight: "Fits, but snug", no: "Won't fit" };
    if (!v) {
      $("result").innerHTML = '<span>Pick what you carry to see if it fits.</span>';
      $("note").hidden = true;
    } else {
      var html = '<span>' + esc(bag.name) + ':</span><b class="' + (v.level === "ok" ? "ok" : v.level === "no" ? "no" : "") + '">' + LABEL[v.level] + "</b>";
      // a Tully in another size that fits better gets its own "Choose" button
      var sib = others.filter(function (o) { return o.b.family === bag.family && o.v && o.v.level !== "no"; }).sort(function (a, b) { return a.b.vol - b.b.vol; })[0];
      if (sib && v.level === "no") html += '<button type="button" class="pick" data-bag="' + sib.b.id + '">Choose ' + esc(sib.b.size) + "</button>";
      $("result").innerHTML = html;
      var pct = Math.round(v.share * 100), fits = v.rows.filter(function (r) { return r.ok; });
      var msg;
      if (v.level === "no" && fits.length < v.rows.length) {
        var bad = v.rows.filter(function (r) { return !r.ok; });
        var alt = others.filter(function (o) { return o.v.level !== "no"; }).sort(function (a, b) { return (a.b.family === bag.family ? 0 : 1) - (b.b.family === bag.family ? 0 : 1) || (a.b.vol || 0) - (b.b.vol || 0); })[0];
        msg = "<b>" + esc(bad.map(function (r) { return r.it.name; }).join(" and ")) + "</b> won't go in the " + esc(bag.name) + ". " + (alt ? (alt.b.family === bag.family ? "Go up to the <b>" : "The smallest Flying Solo bag that takes everything you've picked is the <b>") + esc(alt.b.name) + "</b>." : "Nothing in the Flying Solo range takes all of that at once.");
      } else if (v.level === "no") {
        msg = "Each item fits on its own, but together they'd fill about <b>" + pct + "%</b> of the bag, so they won't all go in at once.";
      } else {
        msg = "Everything fits. Together they fill about <b>" + pct + "%</b> of the bag" + (v.level === "tight" ? ", so it'll be a snug pack." : ", leaving room for more.");
      }
      $("note").innerHTML = msg;
      $("note").hidden = false;
    }
    renderScales(v);
    renderDiagram(bag, v);
    $("info").textContent = bag.info;
    // table
    var match = null;
    if (list.length) { var fam = BAGS.filter(function (b) { return judge(b, list).level === "ok"; }).sort(function (a, b) { return (a.vol || 0) - (b.vol || 0); })[0]; match = fam ? fam.id : null; }
    $("chart").innerHTML = BAGS.map(function (b) {
      var rest = b.spaces.slice(1).map(function (s) { return s.name + " " + trio(s.w, s.h, s.d); }).join("<br>") || "–";
      return '<tr class="' + (b.id === S.bag ? "is-cur " : "") + (b.id === match ? "is-match" : "") + '"><th>' + esc(b.name) + "</th><td>" + (b.vol ? b.vol + "L" : b.volText) + "</td><td>" + trio(b.out.w, b.out.h, b.out.d) + "</td><td>" + trio(b.spaces[0].w, b.spaces[0].h, b.spaces[0].d) + "</td><td>" + rest + "</td></tr>";
    }).join("");
    // other bags, Peak Promise style
    $("others").innerHTML = list.length ? others.map(function (o) {
      var sub = o.v.level === "no" ? (o.v.rows.filter(function (r) { return !r.ok; })[0] ? esc(o.v.rows.filter(function (r) { return !r.ok; })[0].it.name + " " + o.v.rows.filter(function (r) { return !r.ok; })[0].why) : "Too much for one bag") : "About " + Math.round(o.v.share * 100) + "% full";
      return '<button type="button" class="prow" data-bag="' + o.b.id + '"><span class="dot ' + o.v.level + '"></span><span class="pn">' + esc(o.b.name) + "<small>" + sub + '</small></span><span class="ps ' + o.v.level + '">' + LABEL[o.v.level] + "</span></button>";
    }).join("") : '<span class="pn" style="color:var(--muted)">Pick what you carry to compare every bag.</span>';
  }

  root.addEventListener("click", function (e) {
    var t = e.target.closest("[data-bag],[data-item],[data-custom],[data-u],#fsgf-clear");
    if (!t) return;
    if (t.hasAttribute("data-bag")) {
      S.bag = t.getAttribute("data-bag");
      try { var q = new URLSearchParams(location.search); q.set("bag", S.bag); history.replaceState(null, "", location.pathname + "?" + q.toString()); } catch (err) {}
      if (!t.classList.contains("chip")) root.scrollIntoView({ behavior: "smooth" });
    }
    else if (t.hasAttribute("data-item")) { var id = t.getAttribute("data-item"), i = S.picked.indexOf(id); if (i > -1) S.picked.splice(i, 1); else S.picked.push(id); }
    else if (t.hasAttribute("data-custom")) S.custom.splice(+t.getAttribute("data-custom"), 1);
    else if (t.hasAttribute("data-u")) S.units = t.getAttribute("data-u");
    else if (t.id === "fsgf-clear") { S.picked = []; S.custom = []; }
    render();
  });
  var form = $("custom");
  function readCustom() {
    var f = S.units === "in" ? 2.54 : 1;
    var d = ["c-l", "c-w", "c-d"].map(function (id) { return parseFloat($(id).value) * f; });
    return d.every(function (n) { return n > 0 && n < 300; }) ? d : null;
  }
  form.addEventListener("input", function () { $("c-add").disabled = !readCustom(); });
  form.addEventListener("submit", function (e) {
    e.preventDefault();
    var d = readCustom(); if (!d) return;
    S.custom.push({ name: $("c-name").value.trim() || "Your item", d: d, kind: "box" });
    ["c-name", "c-l", "c-w", "c-d"].forEach(function (id) { $(id).value = ""; });
    $("c-add").disabled = true;
    render();
  });
  render();
})();
